import { type LassoAction } from './lasso.action';
import {
  FRONTEND_STATE_LASSO_DRAWING_FINISHED,
  FRONTEND_STATE_LASSO_START,
  FRONTEND_STATE_LASSO_STOP,
  FRONTEND_STATE_ROUTING_LASSO_START,
} from './lasso.actionTypes';
import {
  LassoConfiguration, type LassoState,
} from './lasso.state';

const initialState: LassoState = {
  isActive: false,
  isDrawing: false,
};

export const lassoReducer = (state = initialState, action: LassoAction): LassoState => {
  switch (action.type) {

    case FRONTEND_STATE_LASSO_START: {
      return {
        ...state,
        isActive: true,
        isDrawing: true,
        configuration: LassoConfiguration.LassoTool,
      };
    }

    case FRONTEND_STATE_ROUTING_LASSO_START: {
      return {
        ...state,
        isActive: true,
        isDrawing: true,
        configuration: LassoConfiguration.RoutingSelection,
      };
    }

    case FRONTEND_STATE_LASSO_DRAWING_FINISHED: {
      return {
        ...state,
        isDrawing: false,
      };
    }

    case FRONTEND_STATE_LASSO_STOP: {
      return {
        ...state,
        isActive: false,
        isDrawing: false,
      };
    }

    default:
      return state;
  }
};
